import { Zap } from "lucide-react";
import { cn } from "@/lib/utils";

export default function BadgeBoost({ className = "" }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-[11px] font-semibold text-brand-ink shadow-hairline",
        className
      )}
    >
      <Zap size={12} strokeWidth={2.5} fill="currentColor" className="text-amber-500" />
      Boosted
    </span>
  );
}
